import * as yup from 'yup';

export const schema = yup.object().shape({
  des_controle: yup.string().required(),
});
